import { Navigate, RouteObject } from "react-router-dom";
import { Routes } from "../routes";
import { lazy } from "react";

const Login = lazy(() => import('views/login'));
const CreatAccount = lazy(() => import('views/registration/createAccount'));
const VerifyEmail = lazy(() => import('views/registration/verifyEmail'));
const AcceptInvite = lazy(() => import('views/registration/acceptInvite'));
const MfaSetup = lazy(() => import('views/mfaSetup'));
const ForgotPassword = lazy(() => import('views/forgotPassword'));
const ResetPassword = lazy(() => import('views/forgotPassword/resetPassword'));


// login , register, others
export const authenticationRoutes = () => {
    return [
      {
        path: Routes.login,
        element: <Login />,
      },
      {
        path: Routes.createAccount,
        element: <CreatAccount />,
      },
      {
        path: Routes.verifyEmail,
        element: <VerifyEmail/>
      },
      {
        path: Routes.acceptInvite,
        element: <AcceptInvite/>
      },
      {
        path: Routes.mfaSetup,
        element: <MfaSetup/>
      },
      {
        path: Routes.forgotPassword,
        element: <ForgotPassword/>
      },
      {
        path: Routes.resetPassword,
        element: <ResetPassword/>
      },
      {path: Routes.auth, element: <Navigate to={Routes.login} replace/> }
    ] as RouteObject[];
  };